import $ from 'jquery'

const reNonEmptyStr = /\S+/

function parseDateUTC(val) {
  // Unix epoch is in seconds.
  const epoch = parseInt(val, 10)
  if (!isNaN(epoch)) {
    // N.B. Date expects milliseconds.
    return new Date(epoch * 1000)
  }
}

function formatElemFn(format) {
  return function () {
    const $this = $(this)
    let formatted
    try {
      formatted = format($this.attr('data-value'))
      if (formatted) {
        $this.html(formatted)
      }
    } catch (_) {
      // Ignore error.
    }
  }
}

function formatElemAsDateFn(formatDate) {
  return formatElemFn(value => {
    let date
    // Stop if value is an empty string.
    if (value && reNonEmptyStr.test(value)) {
      date = parseDateUTC(value)
      // Stop if parse fn returns "Invalid Date".
      if (date && !isNaN(date)) {
        return formatDate(date)
      }
    }
  })
}

function formatDate(dateObj) {
  // N.B. Use `.toLocaleString()` to support IE 9+
  return dateObj.toLocaleString({}, {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
  })
}

function formatDateTime(dateObj) {
  // N.B. Use `.toLocaleString()` to support IE 9+
  return dateObj.toLocaleString({}, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  })
}

// Format date and date time elements
$('[data-value][data-format=date-utc]').each(formatElemAsDateFn(formatDate))
$('[data-value][data-format=datetime-utc]').each(formatElemAsDateFn(formatDateTime))

// Format email (mailto) links
const emailInput = $('<input type="email" required>').get(0)
if (emailInput && 'validity' in emailInput) {
  $('[data-format=email]').each(formatElemFn(email => {
    $(emailInput).val(email) // set value of input
    if (emailInput.validity.valid) {
      return '<a href="mailto:' + email + '">' + email + '</a>'
    }

    return email
  }))
}
